<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="500">
            <v-card>
                <v-card-title>{{ title }}</v-card-title>
                <v-card-subtitle>{{ $t('USER_SUBTITLE') }}</v-card-subtitle>
                <v-card-text>
                    <div
                        class="text-center"
                        v-if="loading.data">
                        <v-progress-circular
                            indeterminate
                            color="primary">
                        </v-progress-circular>
                    </div>
                    <v-form
                        v-model="valid"
                        ref="form"
                        v-if="!loading.data">
                        
                        <v-text-field
                            :label="$t('USER_USERNAME')"
                            v-model="form.username"
                            :rules="rules.username"
                            :disabled="uneditableField('username')">
                        </v-text-field>
                        
                        <v-text-field
                            :label="$t('USER_NAME')"
                            v-model="form.name"
                            :rules="rules.name"
                            :disabled="uneditableField('name')">
                        </v-text-field>
                        
                        <v-switch
                            v-if="editMode"
                            :label="$t('USER_DLG_SWITCH_CHNG_PASS')"
                            v-model="modifyPassword">
                        </v-switch>
                        <v-text-field
                            v-if="modifyPassword"
                            :label="$t('USER_PASSWORD')"
                            v-model="form.password"
                            :rules="rules.password"
                            type="password">
                        </v-text-field>
                        <v-text-field
                            v-if="modifyPassword"
                            :label="$t('USER_CONF_PASSWORD')"
                            v-model="form.password_confirmation"
                            :rules="rules.password_confirmation"
                            type="password">
                        </v-text-field>
                        <v-switch
                            v-if="editMode"
                            :label="$t('USER_DLG_SWITCH_STATE')"
                            v-model="form.inactive">
                        </v-switch>

                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        @click="submit"
                        :disabled="!valid || loading.submit"
                        :loading="loading.submit">
                        {{ $t('BTN_SAVE') }}
                    </v-btn>
                    <v-btn
                        text
                        @click="close">
                        {{ $t('BTN_CANCEL') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import uneditableField from '../utils/uneditableField';
import AlertDialog from '../components/AlertDialog';
export default {
    name: "UserDialog",
    components: {
        AlertDialog
    },
    data() {
        return {
            display: false,
            valid: false,
            editMode: false,
            modifyPassword: true,
            form: {
                id: null,
                username: null,
                name: null,
                password: null,
                password_confirmation: null,
                inactive: null
            },
            rules: {
                username: [
                    v => !!v || this.$t('RULES_REQUIRED_MSG'),
                    v => /^[a-zA-Z0-9_]{5,16}$/.test(v) || this.$t('USER_RUL_USERNAME_FORMAT')
                ],
                name: [
                    v => !!v || this.$t('RULES_REQUIRED_MSG')
                ],
                password: [
                    v => !!v || this.$t('RULES_REQUIRED_MSG'),
                    v => v.length >= 8 || this.$t('PASS_MIN8CHAR_MSG')
                ],
                password_confirmation: [
                    v => !!v || this.$t('RULES_REQUIRED_MSG'),
                    v => v == this.form.password || this.$t('PASS_CONF_MISMAT_MSG')
                ]
            },
            loading: {
                submit: false,
                data: true
            }
        }
    },
    computed: {
        ...mapState("user", ["user"]),
        title() {
            if(!this.editMode) return this.$t('USER_NEW_TITLE');
            else return this.$t('USER_EDIT_TITLE')
        }
    },
    methods: {
        ...mapActions("user", ["storeUser", "updateUser", "fetchUser", "fetchUsers"]),
        uneditableField,
        async open(params) {
            this.editMode = params.editMode;
            this.display = true;
            this.modifyPassword = true;
            if(this.editMode) {
                this.modifyPassword = false;
                await this.fetchUser(params.id);
                this.form = this.user;
                this.form.password = null;
            }
            this.loading.data = false;
        },
        close() {
            this.display = false;
            this.loading.submit = false;
            this.loading.data = true;
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
        },
        submit() {
            this.loading.submit = true;
            if(!this.editMode) {
                this.storeUser(this.form)
                    .then(response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        this.fetchUsers();
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            } else {
                // pull the password field out of the request if not modifying
                if(!this.modifyPassword) delete this.form["password"];
                this.updateUser(this.form)
                    .then(response => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        this.fetchUsers();
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            }
        }
    }
}
</script>